import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import React from "react";

const ImpressumPage: React.FC = () => (
  <>
    <Container maxWidth="md" sx={{ pt: 6, pb: 8 }}>
      <Box>
        <Typography variant="h2" sx={{ mb: 2 }}>
          Impressum
        </Typography>
        <Typography component="div" sx={{ mb: 1 }}>
          <strong>WBL Steeldartliga Baden-Württemberg</strong>
          <br />
          Ferdinand Schneider
          <br />
          E-Mail:{" "}
          <a
            href="mailto:wuerttemberg-dart-liga@gmx.de"
            style={{
              color: "#1976d2",
              textDecoration: "underline",
            }}
          >
            wuerttemberg-dart-liga@gmx.de
          </a>
        </Typography>
        <Typography sx={{ mb: 1 }}>
          Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV: Ferdinand
          Schneider
        </Typography>
        <Typography sx={{ mt: 3, mb: 1 }}>
          Die <strong>WBL Steeldartliga Baden-Württemberg</strong> ist eine
          unabhängige Dartliga für Hobbyspieler und Steeldart-Enthusiasten in
          Baden-Württemberg. Ziel ist die Förderung des Steeldartsports und die
          Vernetzung von Dartvereinen und Hobbymannschaften in der Region.
        </Typography>
        <Typography sx={{ mb: 1 }}>
          Alle Informationen, Tabellen, Ergebnisse und Bilder auf dieser Website
          dienen ausschließlich dem Zweck, die Steeldart-Community in
          Baden-Württemberg zu unterstützen und den Austausch zwischen
          Dartspielern zu fördern.
        </Typography>
        <Typography sx={{ mb: 1 }}>
          Stichworte: Steeldart, Baden-Württemberg, Dartliga, Hobby, Darts,
          Dartverein, Dartturnier, Liga, Hobbyliga
        </Typography>
        <Box sx={{ mt: 4 }}>
          <Typography variant="h4" sx={{ mb: 2 }}>
            Steeldart Teams in Baden-Württemberg
          </Typography>
          <Typography sx={{ mb: 2 }}>
            In der WBL Steeldartliga spielen Teams aus ganz Baden-Württemberg.
            Hier eine Auswahl der aktuellen Mannschaften und ihrer Spielorte –
            ideal für alle, die Steeldart in ihrer Region suchen:
          </Typography>
          <ul>
            <li>
              <strong>Dart Vader</strong> – Steeldart in Balingen, Gaststätte
              Bären, Ebertstr. 12, 72336 Balingen
            </li>
            <li>
              <strong>Dartchaoten</strong> – Steeldart in Köngen, Musik Café
              Eisele, Bahnhofstr. 1, 73257 Köngen
            </li>
            <li>
              <strong>Time Darter</strong> – Steeldart in Wildberg, Rockcafe
              Cliff, Kochsteige 1, 72218 Wildberg
            </li>
            <li>
              <strong>Mechthild's Pfeilgarde</strong> – Steeldart in Rottenburg
              am Neckar, Haus der Bürgerwache, Tübinger Str. 39, 72108
              Rottenburg
            </li>
            <li>
              <strong>DC Lindenhof 1 & 2</strong> – Steeldart in Kusterdingen,
              Vereinsheim DC Lindenhof, Jahnstraße 46/3, 72127 Kusterdingen
            </li>
            <li>
              <strong>Drunk Bastards</strong> – Steeldart in Gärtringen, Pilsi
              Gärtringen, Grabenstraße 62a, 71116 Gärtringen
            </li>
            <li>
              <strong>Corner DC</strong> – Steeldart in Rottenburg am Neckar,
              Ehgner Eck, Ehgner Platz 2, 72108 Rottenburg
            </li>
            <li>
              <strong>Dartarossa</strong> – Steeldart in Reutlingen, Cafe Bar
              Metropol, Heubergstraße 3, 72766 Reutlingen
            </li>
            <li>
              <strong>DC Buderhof</strong> – Steeldart in Oberreichenbach,
              Wildbader Str. 51, 75394 Oberreichenbach
            </li>
          </ul>
          <Typography
            sx={{ mt: 2, fontSize: "0.95rem", color: "text.secondary" }}
          >
            Suchen Sie Steeldart in Balingen, Rottenburg, Reutlingen, Köngen,
            Wildberg, Kusterdingen oder Gärtringen? Die WBL Steeldartliga
            Baden-Württemberg bietet Teams und Spielorte in Ihrer Nähe!
          </Typography>
        </Box>
      </Box>
    </Container>
  </>
);

export default ImpressumPage;
